<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.material"
        ref="DataTable"
        sort-by="descricao"
        :disabled-button-search="true"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-material-edit', params: { id: item.id } })"
                color="primary"
                authorize="update-cadastro-material"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                authorize="destroy-cadastro-material"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material')
        }
    },
    computed: {

        fields() {

            return [
                {
                    name: 'descricao',
                    key: 'descricao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'codigo_material',
                    key: 'codigoMaterial',
                    label: 'Código',
                    searchable: true,
                    sortable: true,
                    class: 'col-min'
                },
                {
                    name: 'apresentacao',
                    key: 'apresentacao',
                    label: 'Apresentação',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_grupo.nome',
                    key: 'grupo',
                    label: 'Grupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_subgrupo.nome',
                    key: 'subgrupo',
                    label: 'Subgrupo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.material.destroy(id)
                .then(() => this.$refs.DataTable.search())

            this.showDeleteConfirmation('Deseja realmente excluir o material?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>